class PlotScatter extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let {
      data,
      scaleX,
      scaleY,
      getX,
      getY,
      color,
      size
    } = this.props;

    let canvas = this.refs.canvas;
    canvas.width = canvas.width;

    let ctx = canvas.getContext("2d");

    ctx.fillStyle = color;
    ctx.beginPath();

    data.forEach((d, i) => {
      let x = scaleX(getX(d, i)) * 2;
      let y = scaleY(getY(d)) * 2;
      let r = size;

      ctx.moveTo(x, y);
      ctx.arc(x, y, r, 0, Math.PI * 2);
    });

    ctx.fill();
  }

  render() {
    let { width, height } = this.props;

    return (
      <foreignObject className="mc-plot-raster-scatter" width={width} height={height}>
        <canvas ref="canvas" width={width * 2} height={height * 2} style={{ width, height }}/>
      </foreignObject>
    );
  }
}

PlotScatter.defaultProps = {
  size: 6,
  color: "#304561"
};

module.exports = PlotScatter;